module.exports = __webpack_public_path__ + "img/img_applet.d7553868.png";